import { RouteProps } from '../../routes/AppRouter'
import React from 'react'
import { Registration as RegistrationForm } from '../../features/registration/Registration'
import { Box } from '@mui/material'
import logoCareme from '../../assets/caremeLogoMain.svg'
import style from '../layout/Main.module.css'

type RegistrationProps = {
  token?: string
} & RouteProps

export function Registration(props: RegistrationProps) {
  const token = props.token || ''
  return (
    <>
      <RegistrationForm token={token} />
      <Box display={'flex'} justifyContent={'flex-end'}>
        <img src={logoCareme} alt="Logo Careme" className={style.logo} />
      </Box>
    </>
  )
}
